import { render, staticRenderFns } from "./SaveStateIndicator.vue?vue&type=template&id=5a770a10&scoped=true&"
import script from "./SaveStateIndicator.vue?vue&type=script&lang=ts&"
export * from "./SaveStateIndicator.vue?vue&type=script&lang=ts&"
import style0 from "./SaveStateIndicator.vue?vue&type=style&index=0&id=5a770a10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a770a10",
  null
  
)

export default component.exports